import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {IdentityEmun} from './constant'

// 发放特权
export async function privilege_send(arg) {
  const res = await http.post('/live/privilege/privilege_send', {
    ...window.store.getState().env.deviceinfo,
    operator: String(window.store.getState().env.deviceinfo.h_m),
    from: 1,
    ...arg,
  })
  return res.data
}
// 管理库存
export async function process_privilege_package(arg) {
  const res = await http.post('/live/privilege/process_privilege_package', {
    ...window.store.getState().env.deviceinfo,
    operator: String(window.store.getState().env.deviceinfo.h_m),
    from: 1,
    ...arg,
  })
  return res.data
}
// 一键加满库存 只有admin有
export async function process_privilege_package_all(arg) {
  const res = await http.post('/live/privilege/process_privilege_package_all', {
    ...window.store.getState().env.deviceinfo,
    operator: String(window.store.getState().env.deviceinfo.h_m),
    from: 1,
    ...arg,
  })
  return res.data
}
// 查询用户 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132044752
export async function check_member_by_id(arg) {
  const res = await http.post('/live/account/get_member_info_by_show_id', {
    ...window.store.getState().env.deviceinfo,
    ...arg,
  })
  return res.data
}
// 提升用户等级
export async function upgrade_by_mid(arg) {
  const res = await http.post('/live/privilege/upgrade_by_mid', {
    ...window.store.getState().env.deviceinfo,
    operator: String(window.store.getState().env.deviceinfo.h_m),
    from: 1,
    ...arg,
  })
  return res.data
}

// [查询礼包列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=148315861
export const privilege_package_list = createAsyncThunk(
  '/live/privilege/privilege_package_list',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<InitialStateType>>(
      '/live/privilege/privilege_package_list',
      {
        ...store.getState().env.deviceinfo,
        ...store.getState().env.otherInfo,
        from: 1,
        operator: String(store.getState().env.deviceinfo.h_m),
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export type PackageItem = {
  id?: number
  privilege_id?: number // 特权id
  package_type?: number // 礼包类型：1迎新 2公会长
  type?: number // 特权种类
  name?: string
  level?: number
  icon?: string
  icon_h5?: string
}
export interface InitialStateType {
  identity?: number // 当前登录账号的身份
  titleName?: string
  packListInfo?: {
    list?: Array<PackageItem>
    max_add_num?: number
  }
  memberList?: Array<{
    id?: number
    name?: string
    member_num?: number // 成员数
    privilege_num?: number // 剩余道具数
    out_num?: number // 已发放道具数
    current_month_income?: number // 本月收入
    last_month_income?: number // 上月收入
  }>
}

const initialState: InitialStateType = {
  identity: IdentityEmun.公会长, // 默认公会长
  titleName: 'Habi',
  packListInfo: {},
  memberList: [],
}

export const WelcomePackSlice = createSlice({
  name: 'WelcomePack',
  initialState,
  reducers: {
    // 当前登录账号的身份
    setIdentity: (state, action) => {
      Object.assign(state, {
        identity: action.payload,
      })
    },
    // 当前管理的公会/bd 名称
    setTitleName: (state, action) => {
      Object.assign(state, {
        titleName: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(privilege_package_list.fulfilled, (state, action) => {
      Object.assign(state.packListInfo, action.payload)
    })
  },
})
export default WelcomePackSlice.reducer
export const WelcomePackActions = WelcomePackSlice.actions
